// document.addEventListener('DOMContentLoaded', function () {
//     document.querySelectorAll('.product-swiper').forEach(function (el) {
//         new Swiper(el, {
//             slidesPerView: 1,
//             slidesPerGroup: 1,
//             spaceBetween: 16,
//             loop: false,
//             pagination: {
//                 el: el.querySelector('.swiper-pagination'),
//                 clickable: true,
//             },
//             navigation: {
//                 nextEl: el.querySelector('.swiper-button-next'),
//                 prevEl: el.querySelector('.swiper-button-prev'),
//             },
//             breakpoints: {
//                 1024: {
//                     slidesPerView: 3,
//                     slidesPerGroup: 3,
//                     spaceBetween: 45,
//                 }
//             }
//         });
//     });
// });

function initSwipers() {
    document.querySelectorAll('.product-swiper').forEach(function (el) {
        if (el.swiper) return; // verhindert doppelte Initialisierung
        new Swiper(el, {
            slidesPerView: 1,
            slidesPerGroup: 1,
            spaceBetween: 16,
            loop: false,
            pagination: {
                el: el.querySelector('.swiper-pagination'),
                clickable: true,
                dynamicBullets: true,
            },
            navigation: {
                nextEl: el.querySelector('.swiper-button-next'),
                prevEl: el.querySelector('.swiper-button-prev'),
            },
            breakpoints: {
                1024: {
                    slidesPerView: 3,
                    slidesPerGroup: 3,
                    spaceBetween: 45,
                }
            }
        });
    });
}

document.addEventListener('DOMContentLoaded', initSwipers);

document.addEventListener('DOMContentLoaded', function () {
    const observer = new MutationObserver(function () {
        initSwipers();
    });

    document.querySelectorAll('product-recommendations').forEach(function (el) {
        observer.observe(el, {childList: true, subtree: true});
    });
});